import { useCurrentTeam } from '@/providers/TeamProvider';
import { useMonthlySalesTargets } from '@/hooks/api/0230_monthly_sales_targets';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

export const MonthlySalesTargetsElement = () => {
  const { _w_, me, _t_, isAdmin } = useCurrentTeam();
  const { data } = useMonthlySalesTargets({ identifier: _w_!.identifier, team_id: _t_!.id });
  const [monthLabels, setMonthLabels] = useState<number[]>();

  useEffect(() => {
    const closingMonth = moment(_w_!.closing_month, 'MM');
    const _monthLabels = [...Array(12)].map(() => {
      closingMonth.add(1, 'month');
      return closingMonth.toDate().getMonth() + 1;
    });

    setMonthLabels(_monthLabels);
  }, []);

  return (
    <div className="card mb-4">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-8">
          <h5 className="mb-1">チーム売上目標</h5>
          <p className="text-xs mb-0">設定すると、ダッシュボードで売上目標と実績の差分を見ることができます</p>
        </div>
        <div className="col-md-4 d-flex justify-content-end">
          {isAdmin && (
            <Link
              to={`/w/${_w_!.identifier}/setting/teams/${_t_!.id}/monthly_sales_targets`}
              className="btn bg-gradient-primary btn-icon"
            >
              <i className="fas fa-edit"></i>目標設定
            </Link>
          )}
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="table-responsive">
          <table className="table align-items-center">
            <thead>
              <tr>
                <th className="bg-white" style={{ position: 'sticky', left: 0, zIndex: 999 }}>
                  &nbsp;
                </th>
                {monthLabels?.map((m) => (
                  <th
                    key={`m-label-${m}`}
                    className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  >
                    {m}月
                  </th>
                ))}
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder px-2 bg-white"
                  style={{ position: 'sticky', right: 0, zIndex: 999 }}
                >
                  合計
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-xs text-dark font-weight-bold bg-white" style={{ position: 'sticky', left: 0 }}>
                  前期
                </td>
                {data?.previous_sales_targets.map((d, i) => (
                  <td key={`p-s-${i}`} className="text-xxs">
                    ¥{d.amount.toLocaleString()}
                  </td>
                ))}
                <td className="text-xxs text-dark font-weight-bold bg-white" style={{ position: 'sticky', right: 0 }}>
                  ¥{data?.previous_sales_targets.reduce((sum, d) => sum + d.amount, 0).toLocaleString()}
                </td>
              </tr>
              <tr>
                <td
                  className="text-xs text-dark font-weight-bold bg-table-even"
                  style={{ position: 'sticky', left: 0 }}
                >
                  今期
                </td>
                {data?.current_sales_targets.map((d, i) => (
                  <td key={`c-s-${i}`} className="text-xxs">
                    ¥{d.amount.toLocaleString()}
                  </td>
                ))}
                <td
                  className="text-xxs text-dark font-weight-bold bg-table-even"
                  style={{ position: 'sticky', right: 0 }}
                >
                  ¥{data?.current_sales_targets.reduce((sum, d) => sum + d.amount, 0).toLocaleString()}
                </td>
              </tr>
              <tr>
                <td className="text-xs text-dark font-weight-bold bg-white" style={{ position: 'sticky', left: 0 }}>
                  来期
                </td>
                {data?.next_sales_targets.map((d, i) => (
                  <td key={`n-s-${i}`} className="text-xxs">
                    ¥{d.amount.toLocaleString()}
                  </td>
                ))}
                <td className="text-xxs text-dark font-weight-bold bg-white" style={{ position: 'sticky', right: 0 }}>
                  ¥{data?.next_sales_targets.reduce((sum, d) => sum + d.amount, 0).toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
